import { render } from "./add-custom-product.vue?vue&type=template&id=5cec0917&ts=true"
import script from "./add-custom-product.ts?vue&type=script&lang=ts&external"
export * from "./add-custom-product.ts?vue&type=script&lang=ts&external"

import "./add-custom-product.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__